import { render, staticRenderFns } from "./PlanUpgradeForm.vue?vue&type=template&id=0a45e3f7&"
import script from "./PlanUpgradeForm.vue?vue&type=script&lang=js&"
export * from "./PlanUpgradeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports